import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-not-allowed',
  standalone: false,
  templateUrl: './not-allowed.component.html',
  styleUrls: ['./not-allowed.component.scss'],
})
export class NotAllowedComponent implements OnInit {
  constructor(public appService: AppService, private authService: AuthService) { }

  // Variables fetched from local storage
  upn: string;

  ngOnInit(): void {
    this.upn = localStorage.getItem(environment.localStorage.userUpn);
  }

  /**
   * Calls the logout service.
   *
   * @returns void
   */
  logout(): void {
    this.authService.logout();
  }
}
